/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable global-require */
import React, { useEffect, useState } from "react";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { filters } from "../../../assets/data/videos";
import { igemLogoDark, videos } from "../../../assets/icons";

import "./styles.scss";
import { VideoDialog } from "../../../components/VideoDialog/video-dialog";

interface VideoCardProps {
  video: Video;
}
export interface Video {
  videoId: string;
  title: string;
  topic: string;
  id: number;
  thumbnailPath: string;
  duration: number;
}

const toHHMMSS = (secs: number) => {
  const hours = Math.floor(secs / 3600);
  const minutes = Math.floor(secs / 60) % 60;
  const seconds = secs % 60;

  return [hours, minutes, seconds]
    .map((v) => (v < 10 ? `0${v}` : v))
    .filter((v, i) => v !== "00" || i > 0)
    .join(":");
};

const getTopicColor = (topic: string): string | undefined =>
  filters.find((filter) => filter.name === topic)?.color;

export const VideoCard = (props: VideoCardProps): JSX.Element => {
  const { video } = props;
  const { id, title, topic, videoId, thumbnailPath, duration } = video;
  const [open, setOpen] = useState(false);
  const [thumbnail, setThumbnail] = useState<string>(igemLogoDark);

  useEffect(() => {
    import(`../../../assets/media/${thumbnailPath}`)
      .then((image) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        setThumbnail(image.default);
        return true;
      })
      .catch(() => {
        setThumbnail(igemLogoDark);
      });
  }, []);

  return (
    <>
      <li className="vc" style={{ borderColor: getTopicColor(topic) }}>
        <div>
          <button
            type="button"
            className="vc-thumbnail"
            onClick={() => setOpen(true)}
          >
            <div className="vc-thumbnail-wrapper">
              <img src={thumbnail} alt={`video-${id}`} />
              <div className="vc-thumbnail-cover">
                <img src={videos} alt={`play-${id}`} />
              </div>
            </div>
          </button>
          <div className="vc-duration">
            <ScheduleIcon fontSize="small" />
            <p>{toHHMMSS(duration)}</p>
          </div>
        </div>
        <div className="vc-meta">
          <p>{title}</p>
        </div>
        <div className="vc-topic">
          <p style={{ color: getTopicColor(topic) }}>{topic}</p>
          <div className="vc-topic-border" />
        </div>
      </li>
    <VideoDialog open={open} setOpen={setOpen} title={title} videoId={videoId}/>
    </>
  );
};
